export default __webpack_public_path__ + "static/media/0x948d2a81086a075b3130bac19e4c6dee1d2e3fe8.4802a741.png";